module.exports = __webpack_public_path__ + "img/infoRepresa.332e93b5.jpg";